
const customValid = require('./customValidation.js');
const _ = require('lodash');
import ko from 'rgs-knockout';
const Serializable = require('serializable');
const vb = require('validation-builder');

function commonInfomation () {
	const src = Serializable({
		PersonType: ko.observable().extend({required: true}),
		IsIndividual: ko.pureComputed(function () {
			return src.PersonType() === 'Physical';
		}),
		LastName: ko.observable(),
		FirstName: ko.observable(),
		MiddleName: ko.observable(),
		CompanyName: ko.observable(),
		CompanyContactPerson: ko.observable(),
		xEmail: ko.observable().extend({required: true, email: true }),
		PhoneCityCode: ko.observable().extend({required: true }),
		PhoneNumber: ko.observable().extend({required: true }),
		Region: ko.observable().extend({required: true }),
		LifePolicy: ko.observable(),
		ComplaintText: ko.observable().extend({required: true }),
		CommentFiles: ko.pureComputed(() => {
			return src.ComplaintFiles().concat(src.ConclusionFiles());
		}),
	});

	src.ComplaintFiles = ko.observableArray()
		.extend({
			required: {
				params: true,
				message: 'приложите файлы',
			},
		})
		.extend({
			validation: vb.all([
				vb.everyFileHasExtension('pdf'),
				vb.everyFileMaxSize('1mb'),
				vb.custom(v => {
					return v.length <= 5;
				}, 'не более 5 файлов'),
			]),
		});

	src.ConclusionFiles = ko.observableArray()
		.extend({
			required: {
				params: true,
				message: 'приложите файлы',
			},
		})
		.extend({
			validation: vb.all([
				vb.everyFileHasExtension('pdf'),
				vb.everyFileMaxSize('1mb'),
				vb.custom(v => {
					return v.length <= 5;
				}, 'не более 5 файлов'),
			]),
		});

	src.LastName.extend({
		validation: customValid.cyrrilicOnly,
		required: {
			params: true,
			onlyIf: function (){
				return src.IsIndividual();
			},
		},
	});
	src.FirstName.extend({
		validation: customValid.cyrrilicOnly,
		required: {
			params: true,
			onlyIf: function (){
				return src.IsIndividual();
			},
		},
	});
	src.MiddleName.extend({
		validation: customValid.cyrrilicOnly,
		required: {
			params: true,
			onlyIf: function (){
				return src.IsIndividual();
			},
		},
	});
	src.CompanyName.extend({
		validation: customValid.cyrrilicOnly,
		required: {
			params: true,
			onlyIf: function (){
				return !src.IsIndividual();
			},
		},
	});
	src.CompanyContactPerson.extend({
		validation: customValid.cyrrilicOnly,
		required: {
			params: true,
			onlyIf: function (){
				return !src.IsIndividual();
			},
		},
	});

	src.RegionsList = ko.observableArray([]);
	src.Phone = ko.computed({
		write: function (phone){
			const result = phone.match(/\d+/ig) || [];
			src.PhoneCityCode(result[0]);
			src.PhoneNumber(result.splice(1).join(''));
		},
		read: function (){
			if (!src.PhoneCityCode()) {
				return undefined;
			}

			return '(' + src.PhoneCityCode() + ') ' + src.PhoneNumber();
		},
		owner: src,
	}).extend({ required: true, pattern: /\(\d{3}\) \d{6}/ig });

	return src;
}


function claimSettlement () {
	const src = Serializable({
		InsuranceProductKind: ko.oneOf(['', 'Compulsory', 'Voluntary']),
		AccidentDamageKind: ko.oneOf(['', 'Vehicle', 'Property', 'Health']),
		PaymentRequestNumber: ko.observable(),
		VehicleMaker: ko.observable(),
		VehicleModel: ko.observable(),
		VehicleRegistrationNumber: ko.observable(),
	});

	src.VehicleMakersList = ko.observableArray([]);
	src.VehicleModelsList = ko.observableArray([]);
	src.VehicleModelUpdating = ko.observable(false);

	return src;
}

function selectOffice () {
	const src = Serializable({
		CurrentRegion: ko.observable().extend({required: true }),
		RgsOfficeCity: ko.observable(),
		OfficeAddress: ko.observable().extend({required: true }),
		RgsOfficeRegion: ko.pureComputed(function () {
			return src.CurrentRegion() && src.CurrentRegion().id;
		}),
		RgsOfficeTitle: ko.pureComputed(function () {
			return src.OfficeAddress() && src.OfficeAddress().name;
		}),
		RgsOfficeDivision: ko.pureComputed(function () {
			return src.OfficeAddress() && src.OfficeAddress().address;
		}),
	}, {
		toJS: function (_super){
			return _super();
		},
	});

	src.CitiesList = ko.observableArray();
	src.RegionsList = ko.observableArray();
	src.OfficesList = ko.observableArray();
	src.RgsOfficeDivisionUpdating = ko.observable(false);
	src.RgsOfficeCityUpdating = ko.observable(false);

	return src;
}

function telephoneService () {
	const src = Serializable({
		RgsPhoneNumber: ko.oneOf([
			'',
			'8-800-200-0-900 или 0530',
			'8-800-200-99-77 или (495) 926-99-77',
			'Other',
		]).extend({ required: true }),
		RgsPhoneNumberInput: ko.observable().extend({ pattern: /\(\d{3}\) \d{3}-\d{2}-\d{2}/ }),
		ClientPhoneNumber: ko.observable().extend({
			required: true,
			pattern: /\(\d{3}\) \d{3}-\d{2}-\d{2}/,
		}),
	});

	src.RgsPhoneNumberInput.extend({required: {
		params: true,
		onlyIf: function (){
			return src.RgsPhoneNumber() === 'Other';
		},
	}});

	return src;
}


function responseInfo (predictionName) {
	const src = Serializable({
		By: ko.observableArray(),
		Email: ko.observable(),
		ByEmail: ko.observable(),
		ZipCode: ko.observable(),
		Province: ko.observable(),
		City: ko.observable(),
		Street: ko.observable(),
		House: ko.observable(),
		Block: ko.observable(),
		Apartment: ko.observable(),
	}, {
		toJS: function (_super){
			let js = _super();
			js = _.mapKeys(js, function (val, key){
				return predictionName + key;
			});

			return js;
		},
	});

	src.Type = ko.oneOf(['Email', 'Post']);

	src.ZipCode.extend({required: {
		params: true,
		onlyIf: function (){
			return src.Type() === 'Post';
		},
	},
	});

	src.Province.extend({required: {
		params: true,
		onlyIf: function (){
			return src.Type() === 'Post';
		},
	},
	});
	src.City.extend({required: {
		params: true,
		onlyIf: function (){
			return src.Type() === 'Post';
		},
	},
	});
	src.Street.extend({required: {
		params: true,
		onlyIf: function (){
			return src.Type() === 'Post';
		},
	},
	});
	src.House.extend({required: {
		params: true,
		onlyIf: function (){
			return src.Type() === 'Post';
		},
	},
	});
	src.Apartment.extend({required: {
		params: true,
		onlyIf: function (){
			return src.Type() === 'Post';
		},
	},
	});

	return src;
}

module.exports = {
	commonInfomation: commonInfomation,
	claimSettlement: claimSettlement,
	selectOffice: selectOffice,
	telephoneService: telephoneService,
	responseInfo: responseInfo,
};
